// ============================================================================
// FNE-BRIDGE Frontend - Layout Authentification (login, reset password)
// ============================================================================

import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box, Paper, Typography, useTheme } from '@mui/material';
import logoFneBridge from '../assets/images/logo-fne-bridge.png';

export const AuthLayout: React.FC = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        backgroundColor: theme.palette.mode === 'dark' ? '#121212' : '#F5F7FA',
      }}
    >
      {/* --- Panneau gauche : branding avec logo --- */}
      <Box
        sx={{
          flex: '0 0 45%',
          display: { xs: 'none', md: 'flex' },
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          background: 'linear-gradient(160deg, #1B5E20 0%, #2E7D32 40%, #388E3C 70%, #43A047 100%)',
          color: '#FFFFFF',
          p: 6,
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        {/* Cercles décoratifs */}
        <Box sx={{
          position: 'absolute', top: -100, right: -100,
          width: 350, height: 350, borderRadius: '50%',
          backgroundColor: 'rgba(255,255,255,0.06)',
        }} />
        <Box sx={{
          position: 'absolute', bottom: -140, left: -80,
          width: 450, height: 450, borderRadius: '50%',
          backgroundColor: 'rgba(255,255,255,0.04)',
        }} />
        <Box sx={{
          position: 'absolute', top: '40%', left: -60,
          width: 200, height: 200, borderRadius: '50%',
          backgroundColor: 'rgba(255,255,255,0.03)',
        }} />

        <Box sx={{ position: 'relative', zIndex: 1, textAlign: 'center', maxWidth: 420 }}>
          {/* Logo */}
          <Box
            component="img"
            src={logoFneBridge}
            alt="FNE-Bridge Logo"
            sx={{
              width: 330,
              height: 'auto',
              mb: 3,
              filter: 'drop-shadow(0 4px 20px rgba(0,0,0,0.3))',
            }}
          />

          <Typography variant="h6" fontWeight={400} sx={{ opacity: 0.9, mb: 2, lineHeight: 1.5 }}>
            Plateforme d'interfaçage pour Factures Normalisées Électroniques
          </Typography>
          <Typography variant="body2" sx={{ opacity: 0.65, lineHeight: 1.8 }}>
            Connectez votre ERP, transformez vos données et générez vos
            factures conformes à la réglementation ivoirienne en quelques clics.
          </Typography>
        </Box>
      </Box>

      {/* --- Panneau droit : formulaire --- */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          p: { xs: 3, sm: 6 },
        }}
      >
        <Paper
          elevation={0}
          sx={{
            width: '100%',
            maxWidth: 440,
            p: { xs: 3, sm: 4 },
            borderRadius: 3,
            border: '1px solid',
            borderColor: 'divider',
          }}
        >
          {/* Logo mobile */}
          <Box sx={{ display: { xs: 'block', md: 'none' }, textAlign: 'center', mb: 3 }}>
            <Box
              component="img"
              src={logoFneBridge}
              alt="FNE-Bridge Logo"
              sx={{ width: 200, height: 'auto', mb: 1 }}
            />
          </Box>

          <Outlet />
        </Paper>

        <Typography variant="caption" color="text.secondary" sx={{ mt: 4 }}>
          &copy; {new Date().getFullYear()} FNE-Bridge &mdash; Tous droits réservés
        </Typography>
      </Box>
    </Box>
  );
};
